import { ColorRGBA } from 'q-floodfill';

const isBlack = (color: ColorRGBA) => {
  return color.r === 0 && color.g === 0 && color.b === 0 && color.a !== 0;
};

export default isBlack;
